function setSpecializationField(data) {
    return {
      ...data, 
      lgbtq: data?.lgbtq !== undefined ? data?.lgbtq : false,
    };
  }
  
  export default setSpecializationField;
  